import {
  extractPersonCpf,
} from "src-next/modules/person-batch-register";
import type { CrmPatientSummary } from "../types";

function pickOfficialName(person: fhir5.Person): string {
  const official = person.name?.find((n) => n.use === "official")?.text?.trim();
  if (official) return official;
  const first = person.name?.[0];
  return (
    first?.text?.trim() ||
    [...(first?.given || []), first?.family].filter(Boolean).join(" ").trim() ||
    "Cliente cadastrado"
  );
}

function pickPhone(person: fhir5.Person): string | undefined {
  return (
    person.telecom?.find((t) => t.system === "phone")?.value?.trim() ||
    person.telecom?.[0]?.value?.trim() ||
    undefined
  );
}

/**
 * Person da organização → resumo do extrato.
 * recipientResourceType marca reenvio para Person/{id}.
 */
export function mapFhirPersonToCrmPatientSummary(
  person: fhir5.Person,
): CrmPatientSummary | null {
  const personId = person.id?.trim();
  if (!personId) return null;

  const cpf = extractPersonCpf(person);

  return {
    patientId: personId,
    officialName: pickOfficialName(person),
    birthDate: person.birthDate ?? "",
    phone: pickPhone(person),
    taxIdentifierValue: cpf || undefined,
    recipientResourceType: "Person",
  };
}

export function mapPersonsToCrmPatientSummaries(
  persons: fhir5.Person[],
): CrmPatientSummary[] {
  const result: CrmPatientSummary[] = [];
  for (const person of persons) {
    const mapped = mapFhirPersonToCrmPatientSummary(person);
    if (mapped) result.push(mapped);
  }
  return result;
}
